<template>
    <div class="bg-gray-400 rounded-full w-8 h-8 flex items-center justify-center cursor-pointer">
        <i :class="icon" />
    </div>
</template>

<script>

export default {
    name: 'RoundedIcon',
    props: {
        icon: { type: String, required: true }
    }
}
</script>
